import { useTranslation } from 'react-i18next';
import React from 'react'
// ANTD
import { DetailsContainer } from 'Components/shared/details-container';
import { FetchedUserData } from 'Types/user.types';
import { DataListType } from 'Types/common.types';

interface EmergencyContactsProps {
    userDetails:FetchedUserData;
}

const EmergencyContacts:React.FC<EmergencyContactsProps> = ({
    userDetails,
}) => {

    const { t } = useTranslation();
    const emergencyInfo: DataListType[]  = [
        {
            label:t("label.name"),
            value:userDetails.userRole?.emergencyContactName ?? '-', 
        },
        {
            label:t("label.relationship"),
            value:userDetails.userRole?.relationship ?? '-',
        },
        {
            label:t("label.contactNo"),
            value:userDetails.userRole?.emergencyContactNo?.fullNumber ?? '-',
        },
    ]

    return (
        <>
            <DetailsContainer 
                listOfData={emergencyInfo}
            />
        </>
    )
}

export default EmergencyContacts